/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'share': {
    width: 16,
    height: 16,
    viewBox: '0 0 58.995 58.995',
    data: '<path pid="0" d="M39.927 41.929c-.524.524-.975 1.1-1.365 1.709l-17.28-10.489a9.93 9.93 0 0 0 .716-3.693 9.949 9.949 0 0 0-.715-3.693l17.284-10.409C40.342 18.142 43.454 20 46.998 20c5.514 0 10-4.486 10-10s-4.486-10-10-10-10 4.486-10 10a9.94 9.94 0 0 0 .667 3.562L20.358 23.985c-1.788-2.724-4.866-4.529-8.361-4.529-5.514 0-10 4.486-10 10s4.486 10 10 10c3.495 0 6.572-1.805 8.36-4.529L37.661 45.43a9.987 9.987 0 0 0-.664 3.57 9.932 9.932 0 0 0 2.929 7.071c1.949 1.949 4.51 2.924 7.071 2.924s5.122-.975 7.071-2.924c1.889-1.889 2.929-4.4 2.929-7.071s-1.04-5.183-2.929-7.071c-3.899-3.9-10.242-3.9-14.141 0zM46.998 2c4.411 0 8 3.589 8 8s-3.589 8-8 8-8-3.589-8-8 3.588-8 8-8zm-35 35.456c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8zm40.656 17.201c-3.119 3.119-8.194 3.119-11.313 0A7.95 7.95 0 0 1 38.998 49a7.95 7.95 0 0 1 2.343-5.657c1.56-1.56 3.608-2.339 5.657-2.339s4.097.779 5.657 2.339c1.511 1.511 2.343 3.521 2.343 5.657s-.832 4.146-2.344 5.657z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/share.js